import type { InfluencerData } from "@/features/influencer-monitoring/store/influencerStore";

export const PLATFORM_NAMES = [
  "Facebook",
  "X (Twitter)",
  "Instagram",
  "Reddit",
  "YouTube",
  "TikTok",
] as const;

export const PLATFORM_KEYS: (keyof InfluencerData)[] = [
  "facebook",
  "twitter",
  "instagram",
  "reddit",
  "yt",
  "tiktok",
];

export const PLATFORM_PLACEHOLDERS = [
  "Enter Facebook link here",
  "Enter X (Twitter) link here",
  "Enter Instagram link here",
  "Enter Reddit link here",
  "Enter YouTube link here",
  "Enter TikTok link here",
];

type PlatformData = Omit<InfluencerData, "username">;

export const URL_TEMPLATES: Record<keyof PlatformData, string> = {
  facebook: "https://www.facebook.com/{username}",
  twitter: "https://twitter.com/{username}",
  instagram: "https://instagram.com/{username}",
  reddit: "https://reddit.com/r/{username}",
  yt: "https://youtube.com/@{username}",
  tiktok: "https://tiktok.com/@{username}",
};

export const URL_PATTERNS: Record<keyof PlatformData, RegExp> = {
  facebook: /(?:facebook\.com\/|fb\.com\/)([^/?#]+)/i,
  twitter: /(?:twitter\.com\/|x\.com\/)([^/?#]+)/i,
  instagram: /(?:instagram\.com\/|ig\.com\/)([^/?#]+)/i,
  reddit: /(?:reddit\.com\/r\/)([^/?#]+)/i,
  yt: /(?:youtube\.com\/channel\/|youtube\.com\/c\/|youtube\.com\/@)([^/?#]+)/i,
  tiktok: /(?:tiktok\.com\/@)([^/?#]+)/i,
};
